import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const FormHeader = () => {
    return (
        <>
            <Bootstrap.Form.Group
                as={Bootstrap.Col}
                md="12"
                className="mb-0"
            >
                <div className="display-flex space-between">
                    <div style={{ fontSize: 18 }}>
                        <strong> Campos obligatorios * </strong>
                    </div>
                </div>
            </Bootstrap.Form.Group>
            <Bootstrap.Form.Group
                as={Bootstrap.Col}
                md="12"
                className="mb-25"
            >
                <span style={{ fontSize: 18 }}>
                    Selecciona el talento que posee y su nivel de dominio con
                    estrellas.
                </span>
            </Bootstrap.Form.Group>
        </>
    )
}

export default FormHeader